const formResponseValues = {
  field: 'value',
  text: 'value',
  counter: 'value',
  number: 'value',
  date: 'selectedDate',
  photo: 'photoIdentifiers',
  comboSelection: 'selectedValue',
  multiSelection: 'leftSelectedIndices',
  selection: 'selectedIndex',
  checkbox: 'is_checked',
  additive: 'additive',
  subform: 'additional_form',
  externalSubform: 'externalSubformId',
  staticText: 'title',
};

export default formResponseValues;
